import { Component, OnInit, Input, OnChanges, EventEmitter, Output, SimpleChange, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppOAuthStore } from '../../models/AppOAuthSotarge';
import { Comentario } from '../../models/Shared/Comentario';

@Component({
    selector: 'comentario',
    templateUrl: './comentario.component.html',  
    encapsulation: ViewEncapsulation.None
})

export class ComentarioComponent implements OnInit{
    public comentarios : Array<Comentario> = new Array<Comentario>();
    public comentario : string = '';

    @Input() ngModel : Array<any>
    @Output() ngModelChange : EventEmitter<Array<any>> = new EventEmitter();
    @Input() limit : number = null;
    @Input() allowDelete : boolean = true;

    constructor(private storage : AppOAuthStore){

    }
    ngOnInit() {
        this.ngModel = this.ngModel ? [...this.ngModel] : new Array<Comentario>();
        this.ngModel.forEach((comentario, i) => comentario.id = i)
    }


    agregarComentario(){
        this.ngModel.push(new Comentario(this.comentario, this.storage));
        this.ngModel[this.ngModel.length-1].id = this.ngModel.length;
        this.comentario = '';
        this.ngModelChange.emit(this.ngModel);
    }

    eliminaComentario(comentario : any){
        let idx = this.ngModel.findIndex(c => c.id == comentario.id);
        this.ngModel.splice(idx, 1);
        this.ngModel.forEach((comentario, i) => comentario.id = i)
    }

}